import type { EducatorCohortDetailsResponse } from '@mc/api'
import type { HeroStripConfig } from '../utils/deriveHeroStrip'
import { useEnrollmentBanner } from './useEnrollmentBanner'
import type { EnrollmentBannerState } from './useEnrollmentBanner'
import { useEnrollmentCtaConfig } from './useEnrollmentCtaConfig'
import type { CtaItem } from './useEnrollmentCtaConfig'

export interface LandingEnrollment {
  banner: EnrollmentBannerState
  /** Shortcuts for banner.showWindowBanner / banner.heroStrip. */
  showWindowBanner: boolean
  heroStrip: HeroStripConfig
  primaryCta: CtaItem
  secondaryCta: CtaItem
  isPrimaryLogIn: boolean
}

/**
 * Composes useEnrollmentBanner + useEnrollmentCtaConfig for the three landing
 * pages, forwarding the SSR seed (`initialCohortDetails`) to the banner hook.
 */
export const useLandingEnrollment = (
  initialCohortDetails?: EducatorCohortDetailsResponse,
): LandingEnrollment => {
  const banner = useEnrollmentBanner(initialCohortDetails)
  const { primaryCta, secondaryCta, isPrimaryLogIn } = useEnrollmentCtaConfig()
  return {
    banner,
    showWindowBanner: banner.showWindowBanner,
    heroStrip: banner.heroStrip,
    primaryCta,
    secondaryCta,
    isPrimaryLogIn,
  }
}
